import React, { useState, useEffect } from 'react';
import TruckNotesThread from './TruckNotesThread';

/**
 * A specialized confirmation dialog for putaway operations.
 *
 * Notes are now captured via the multi-note thread (truck_notes table). The
 * receiver can add zero, one, or many notes; each one is auto-tagged
 * 'receiver' because the truck is in the receiving stage.
 */
const PutawayDialog = ({ isOpen, onClose, onConfirm, truckId }) => {
  const [conforming, setConforming] = useState(true);

  useEffect(() => {
    if (isOpen) {
      setConforming(true);
    }
  }, [isOpen]);

  const handleConfirm = () => {
    onConfirm(truckId, 'Putaway', { conforming });
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" onClick={(e) => e.stopPropagation()}>
      <div className="bg-slate-800 rounded-lg p-5 max-w-md w-full mx-4">
        <h3 className="text-lg font-semibold text-white mb-3">
          Ready for Putaway
        </h3>
        <p className="text-slate-300 mb-5">
          Are you sure you want to mark this truck as ready for putaway?
        </p>

        <div className="mb-5">
          <div className="p-3 bg-blue-900/30 border border-blue-600/30 rounded mb-4">
            <h4 className="text-blue-300 font-medium mb-2">Putaway Options</h4>

            <div className="flex items-center mb-3">
              <input
                type="checkbox"
                id="conforming"
                checked={conforming}
                onChange={(e) => setConforming(e.target.checked)}
                className="mr-2 cursor-pointer"
              />
              <label htmlFor="conforming" className="text-sm text-slate-300 cursor-pointer">
                Shipment conforms to requirements
              </label>
            </div>

            <div>
              <label className="block text-sm text-slate-300 mb-1">
                Receiver Notes
              </label>
              <TruckNotesThread
                truckType="inbound"
                truckId={truckId}
                mode="edit"
                theme="dark"
                emptyMessage="No notes yet. Add a note about the receiving process below."
              />
            </div>
          </div>
        </div>

        <div className="flex justify-end space-x-3">
          <button
            className="px-4 py-2 bg-slate-700 text-slate-300 rounded hover:bg-slate-600"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
            onClick={handleConfirm}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default PutawayDialog;
